import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useButtonClickAnalytics } from './use-button-click-analytics';
import {
  trackAdmissionsAdvisorRouteScreenView,
  trackCrmRouteScreenView,
  trackEstimateRouteScreenView,
  trackHubRouteScreenView,
  trackMobileRouteScreenView,
  trackPatientsRouteScreenView,
  trackSpecialistRouteScreenView,
} from './google-analytics';

function useRouteScreenViewAnalytics() {
  const location = useLocation();

  useEffect(() => {
    trackPatientsRouteScreenView(location.pathname);
    trackHubRouteScreenView(location.pathname);
    trackMobileRouteScreenView(location.pathname);
    trackSpecialistRouteScreenView(location.pathname);
    trackEstimateRouteScreenView(location.pathname);
    trackAdmissionsAdvisorRouteScreenView(location.pathname);
    trackCrmRouteScreenView(location.pathname);
  }, [location.pathname]);
}

/**
 * Central route analytics for finpass-ui. Dispatches screen_view events for
 * mapped route prefixes (/patients, /hub, /mobile, /specialist, etc.) on SPA navigation,
 * and button_click events for buttons under /patients, /hub, /mobile, /specialist, and /estimate.
 */
export function RouteAnalyticsListener() {
  useRouteScreenViewAnalytics();
  useButtonClickAnalytics();
  return null;
}

/** @deprecated Use RouteAnalyticsListener */
export const HubRouteAnalyticsListener = RouteAnalyticsListener;
